"use strict";

define('view/tag.select',['underscore', 'uikit/uikit'], function (_, UIKit) {
  var TagItemView = UIKit.Header.extend({
    tagName: 'h5'
  });
  var TagSelectView = UIKit.Container.extend({
    childBindings: {
      text: 'tagName',
      subText: 'description'
    },
    initialize: function initialize(options) {
      UIKit.Container.prototype.initialize.apply(this, arguments);
      this.table = new UIKit.Table({
        headless: true,
        basic: true,
        borderless: true,
        sortable: false,
        selectable: true,
        selection: UIKit.Table.SINGLE_SELECTION,
        selectOnFocus: true,
        collection: this.getOption('collection')
      });
      this.proxyEventsFrom(this.table, {
        withPrefix: 'table'
      });
      var childViewOptions = this.getOption('childViewOptions');
      this.table.columns.set([{
        childView: TagItemView,
        childViewOptions: _.extend({
          bindings: _.clone(this.childBindings)
        }, Mn._getValue(childViewOptions, this))
      }]);
      this.add(this.table);
    },
    onTableChangeValue: function onTableChangeValue(table, model, previous) {
      var row = table.getRow(model),
        previous = table.getRow(previous);
      if (row) {
        row.columnViews[0].inverted = true;
      }
      if (previous) {
        previous.columnViews[0].inverted = false;
      }
    }
  });
  return TagSelectView;
});

